export const NL = {
  "Open document": "Document openen",
  "Upload file": "Upload bestand",
  "Drop file here to upload": "Zet het bestand hier neer om te uploaden",
  "Disc": "Schijf",
  "URL": "URL",
  "FILE": "HET DOSSIER",
  "SIZE": "MAAT",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "Bytes",
  "Loading... Please wait.": "Laden even geduld aub.",
  "Fit Width": "Fit Breedte",
  "Fit Height": "Past de hoogte",
  "Password protected document": "Met wachtwoord beveiligd document",
  "Password": "Wachtwoord",
  "Open": "Open",
  "Password Required": "Wachtwoord benodigd",
  "Incorrect password": "Incorrect wachtwoord",
  "Error": "Fout",
  "Something went wrong": "Er is iets fout gegaan",
  "Server is not available": "Server is niet beschikbaar",
  "of": "van",
  "Please wait...": "Even geduld aub..."
};
